import Immutable from 'immutable';
import * as actionTypes from './actionTypes';
import { SET_ACTIVE_PAGE } from './../common/Pagination/actionTypes';

const INITIAL_STATE = Immutable.fromJS({
    form: {
        formValues: {
            id: '',
            name: '',
            size: '',
            labels_per_sheet: '',
            markup: '',
            active: 1,
            discount_table: []
        },
        formErrors: {},
        isSaving: false
    },
    activeElement: {
        data: null,
        costsTable: [],
        isSavingCostsTable: false,
        isFetching: false,
        discountTable: [],
        isSavingDiscountTable: false
    },
    delete: {
        id: null,
        isDeleting: false
    },
    elements: {
        data: [],
        processedElements: [],
        isFetching: false
    },
    pagination: {
        totalPages: 0,
        selectedPage: 1,
        elementsPerPage: 20
    },
    sort: {
        column: 'name',
        type: 'asc'
    },
    filter: {
        fields: []
    }
});

export default function (state = INITIAL_STATE, action) {
    state = Immutable.fromJS(state);

    if (window.location['pathname'] !== '/label-elements') {
        state = INITIAL_STATE;
        return state.toJS();
    }

    switch (action.type) {
        case actionTypes.FETCH_ELEMENTS:
            state = state.setIn(['elements', 'isFetching'], true)
                .setIn(['elements', 'data'], [])
                .setIn(['elements', 'processedElements'], [])
                .setIn(['pagination', 'totalPages'], 0)
                .setIn(['pagination', 'selectedPage'], 1);
            break;

        case actionTypes.FETCH_ELEMENTS_SUCCESS:
            state = state.setIn(['elements', 'isFetching'], false)
                .setIn(['elements', 'data'], action.payload)
                .setIn(['pagination', 'totalPages'], Math.ceil(action.payload.length / 20))
                .setIn(['pagination', 'selectedPage'], 1);
            break;

        case actionTypes.FETCH_ELEMENTS_FAILURE:
            state = state.setIn(['elements', 'isFetching'], false);
            break;

        case actionTypes.UPDATE_FORM_VALUE:
            state = state.setIn(['form', 'formValues', action.payload.name], action.payload.value);
            break;

        case SET_ACTIVE_PAGE:
            state = state.setIn(['pagination', 'selectedPage'], action.payload);
            break;

        case actionTypes.SET_SORT:
            state = state.setIn(['sort', 'column'], action.payload.column)
                .setIn(['sort', 'type'], action.payload.type);
            break;

        case actionTypes.SET_ELEMENTS:
            state = state.setIn(['elements', 'data'], action.payload);
            break;

        case actionTypes.CHANGE_ATTRIBUTE:
            state = state.setIn(['elements', 'data'], action.payload);
            break;

        case actionTypes.SAVE:
            state = state.setIn(['form', 'isSaving'], true);
            break;

        case actionTypes.SAVE_SUCCESS:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_FAILURE:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_ELEMENT:
            state = state.setIn(['form', 'isSaving'], true);
            break;

        case actionTypes.SAVE_ELEMENT_SUCCESS:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_ELEMENT_FAILURE:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.DELETE_ELEMENT:
            state = state.setIn(['delete', 'isDeleting'], true);
            break;

        case actionTypes.DELETE_ELEMENT_SUCCESS:
            state = state.setIn(['delete', 'isDeleting'], false);
            break;

        case actionTypes.DELETE_ELEMENT_FAILURE:
            state = state.setIn(['delete', 'isDeleting'], false);
            break;

        case actionTypes.SET_ID_FOR_DELETE:
            state = state.setIn(['delete', 'id'], action.payload);
            break;

        case actionTypes.RESET_FORM:
            state = state.setIn(['form', 'formValues'], {
                id: '',
                name: '',
                labels_per_sheet: '',
                size: '',
                markup: '',
                active: 1,
                discount_table: []
            }).setIn(['form', 'formErrors'], {});
            break;

        case actionTypes.SET_FORM_ERRORS:
            state = state.setIn(['form', 'formErrors'], action.payload.errors)
                .setIn(['form', 'formErrorMessages'], action.payload.errorMessages);
            break;

        case actionTypes.SET_FORM_ERROR:
            state = state.setIn(['form', 'formErrors', action.payload.name], action.payload.value)
                .setIn(['form', 'formErrorMessages', action.payload.name], action.payload.errorMessage);
            break;

        case actionTypes.SET_ACTIVE_ELEMENT:
            state = state.setIn(['form', 'formErrors'], {})
                .setIn(['activeElement', 'data'], action.payload)
                .setIn(['activeElement', 'costsTable'], action.payload.costsTable)
                .setIn(['activeElement', 'discountTable'], action.payload.discountTable)
                .setIn(['form', 'formValues', 'id'], action.payload.id)
                .setIn(['form', 'formValues', 'name'], action.payload.name)
                .setIn(['form', 'formValues', 'size'], action.payload.size)
                .setIn(['form', 'formValues', 'labels_per_sheet'], action.payload.labels_per_sheet)
                .setIn(['form', 'formValues', 'markup'], action.payload.markup)
                .setIn(['form', 'formValues', 'active'], action.payload.active)
                .setIn(['form', 'formValues', 'discount_table'], []);
            break;

        case actionTypes.SET_COSTS_TABLE:
            state = state.setIn(['activeElement', 'costsTable'], action.payload);
            break;

        case actionTypes.SAVE_COSTS_TABLE:
            state = state.setIn(['activeElement', 'isSavingCostsTable'], true);
            break;

        case actionTypes.SAVE_COSTS_TABLE_SUCCESS:
            state = state.setIn(['activeElement', 'isSavingCostsTable'], false);
            break;

        case actionTypes.SAVE_COSTS_TABLE_FAILURE:
            state = state.setIn(['activeElement', 'isSavingCostsTable'], false);
            break;

        case actionTypes.RESET_STATE:
            state = INITIAL_STATE;
            break;

        case actionTypes.CHANGE_FILTER:
            state = state.setIn(['pagination', 'selectedPage'], 1)
                .updateIn(['filter', 'fields'], (fields) => {
                    const index = fields.findIndex(field => field.get('name') === action.payload.name);
                    if (action.payload.value === '') {
                        return fields.delete(index);
                    } else {
                        if (index === -1) {
                            return fields.push({ name: action.payload.name, value: action.payload.value });
                        } else {
                            return fields.set(index, { name: action.payload.name, value: action.payload.value });
                        }
                    }
                });
            break;

        case actionTypes.PROCESS_ELEMENTS:
            state = state.setIn(['elements', 'processedElements'], action.payload)
                .setIn(['pagination', 'totalPages'], Math.ceil(action.payload.length / 20));
            break;

        case actionTypes.SAVE_DISCOUNT_TABLE:
            state = state.setIn(['activeElement', 'isSavingDiscountTable'], true);
            break;

        case actionTypes.SAVE_DISCOUNT_TABLE_SUCCESS:
            state = state.setIn(['activeElement', 'isSavingDiscountTable'], false);
            break;

        case actionTypes.SAVE_DISCOUNT_TABLE_FAILURE:
            state = state.setIn(['activeElement', 'isSavingDiscountTable'], false);
            break;

        case actionTypes.ADD_DISCOUNT:
            state = state.updateIn(['activeElement', 'discountTable'], (discountTable) => discountTable.push({
                id: '',
                start_quantity: '',
                end_quantity: '',
                discount: ''
            }));
            break;

        case actionTypes.DELETE_DISCOUNT:
            state = state.updateIn(['activeElement', 'discountTable'], (discountTable) => discountTable.delete(action.payload));
            break;

        case actionTypes.UPDATE_DISCOUNT:
            state = state.updateIn(['activeElement', 'discountTable'], (discountTable) => {
                const discount = discountTable.get(action.payload.index);
                const newDiscount = discount.setIn([action.payload.field], action.payload.value);
                return discountTable.set(action.payload.index, newDiscount);
            });
            break;

        default:
            break;
    }

    return state.toJS();
}
